import content from '@minimany/content/onboarding.json'
import { Icon } from './Icon'
import type { SearchEmptyCause } from '../search/emptyCause'

export type { SearchEmptyCause } from '../search/emptyCause'

interface SearchEmptyStateProps {
  cause: SearchEmptyCause
  onClearSearch: () => void
  onResetFilters: () => void
}

const EMPTY_STATE_COPY: Record<SearchEmptyCause, { title: string; description: string }> = {
  search: { title: content.empty.search.title, description: content.empty.search.body },
  filters: { title: content.empty.filters.title, description: content.empty.filters.body },
  both: { title: content.empty.both.title, description: content.empty.both.body },
  archive: { title: content.empty.archive.title, description: content.empty.archive.body },
  trash: { title: content.empty.trash.title, description: content.empty.trash.body },
  reminders: { title: content.empty.reminders.title, description: content.empty.reminders.body },
  quickAccess: { title: content.empty.quickAccess.title, description: content.empty.quickAccess.body },
  empty: { title: content.welcome.quietTitle, description: content.welcome.quietBody },
}

export function SearchEmptyState({
  cause,
  onClearSearch,
  onResetFilters,
}: SearchEmptyStateProps) {
  const copy = EMPTY_STATE_COPY[cause]
  const showClearSearch = cause === 'search' || cause === 'both'
  const showResetFilters = cause === 'filters' || cause === 'both'

  return (
    <div
      className="card search-empty-state"
      data-empty-cause={cause}
      role="status"
      aria-live="polite"
    >
      <div className="card-body search-empty-state__body">
        <div className="search-empty-state__peek" aria-hidden="true">
          <div className="search-empty-state__eyes">
            <span className="search-empty-state__eye">
              <span className="search-empty-state__pupil" />
            </span>
            <span className="search-empty-state__eye">
              <span className="search-empty-state__pupil" />
            </span>
          </div>
          <span className="search-empty-state__edge" />
        </div>

        <h3 className="card-title search-empty-state__title">{copy.title}</h3>
        <p>{copy.description}</p>

        {showClearSearch || showResetFilters ? (
          <div className="card-actions search-empty-state__actions">
            {showResetFilters ? (
              <button
                type="button"
                className="btn btn-sm btn-primary search-empty-state__action"
                onClick={onResetFilters}
              >
                <span className="search-empty-state__reset-icon" aria-hidden="true">
                  <Icon name="filter" />
                </span>
                Reset filters
              </button>
            ) : null}
            {showClearSearch ? (
              <button
                type="button"
                className={`btn btn-sm search-empty-state__action${showResetFilters ? ' btn-outline' : ' btn-primary'}`}
                onClick={onClearSearch}
              >
                Clear search
              </button>
            ) : null}
          </div>
        ) : null}
      </div>
    </div>
  )
}
